import { render, staticRenderFns } from "./VueFormulate.vue?vue&type=template&id=00bc8703&"
import script from "./VueFormulate.vue?vue&type=script&lang=js&"
export * from "./VueFormulate.vue?vue&type=script&lang=js&"
import style0 from "./VueFormulate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports